import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Cookie } from "lucide-react";
import { CookiePolicyDialog } from "@/components/CookiePolicyDialog";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [policyOpen, setPolicyOpen] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie_consent", "declined");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom-4 duration-500">
        <div className="container max-w-3xl mx-auto">
          <div className="bg-card border rounded-xl shadow-lg p-4 sm:p-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <Cookie className="h-6 w-6 text-primary flex-shrink-0 mt-0.5 sm:mt-0" />
            <div className="flex-1 text-sm text-muted-foreground">
              Vi använder cookies för att förbättra din upplevelse. Läs mer i vår{" "}
              <button
                onClick={() => setPolicyOpen(true)}
                className="underline text-foreground hover:text-primary transition-colors font-medium"
              >
                Cookie Policy
              </button>.
            </div>
            <div className="flex gap-2 flex-shrink-0 w-full sm:w-auto">
              <Button variant="outline" size="sm" onClick={decline} className="flex-1 sm:flex-none">
                Avböj
              </Button>
              <Button size="sm" onClick={accept} className="flex-1 sm:flex-none">
                Godkänn
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CookiePolicyDialog open={policyOpen} onOpenChange={setPolicyOpen} />
    </>
  );
}
